<template>
  <div>
    <div class="card">
      <div class="card-header">
        <a-button
          type="primary"
          class="mb-3"
          @click="sync"
          :loading="syncing"
          title="Sync files now"
          icon="sync"
        >
          Sync files
        </a-button>
      </div>

      <div class="card-body">
        <a-spin :spinning="loading || sending || syncing">
          <a-table
            :scroll="{ x: true }"
            :columns="columns"
            :dataSource="files"
            :pagination="false"
            :row-key="(record) => record.id"
          >
            <span
              slot="status"
              slot-scope="text"
              :class="statusClasses(text)"
              >{{ statusText(text) }}</span
            >
            <span slot="dateFormat" slot-scope="text">{{
              moment(text).format('DD.MM.YYYY')
            }}</span>

            <span slot="dateTimeFormatCges" slot-scope="text, record">
              <span :class="timeClasses(record.cges_xml_sent_at)">{{
                record.cges_xml_sent_at
                  ? moment(record.cges_xml_sent_at).format(
                      'DD.MM.YYYY HH:mm:ss'
                    )
                  : 'not sent'
              }}</span>
              <br />
              <span :class="timeClasses(record.market_prices_xml_sent_at)">{{
                record.market_prices_xml_sent_at
                  ? moment(record.market_prices_xml_sent_at).format(
                      'DD.MM.YYYY HH:mm:ss'
                    )
                  : 'not sent'
              }}</span>
            </span>

            <span
              slot="dateTimeFormatCotee"
              slot-scope="text"
              :class="timeClasses(text)"
              >{{
                text ? moment(text).format('DD.MM.YYYY HH:mm:ss') : 'not sent'
              }}</span
            >

            <span slot="dateTimeFormat" slot-scope="text">{{
              text ? moment(text).format('DD.MM.YYYY HH:mm:ss') : '-'
            }}</span>

            <div slot="errorMessage" slot-scope="text">
              {{ text }}
            </div>

            <span slot="action" slot-scope="record">
              <a-dropdown>
                <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                  Options <a-icon type="down" />
                </a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a-button
                      type="link"
                      @click="() => sendEmail(record, 'cges')"
                      icon="email"
                    >
                      <span>Send to CGES</span>
                    </a-button>
                  </a-menu-item>
                  <a-menu-item>
                    <a-button
                      type="link"
                      @click="() => sendEmail(record, 'cges-prices')"
                      icon="email"
                    >
                      <span>Send Prices to CGES</span>
                    </a-button>
                  </a-menu-item>
                  <a-menu-item>
                    <a-button
                      type="link"
                      @click="() => sendEmail(record, 'cotee')"
                      icon="email"
                    >
                      <span>Send to COTEE</span>
                    </a-button>
                  </a-menu-item>
                  <a-menu-item>
                    <a-button
                      type="link"
                      @click="() => sendEmail(record, 'entsoe')"
                      icon="email"
                    >
                      <span>Send to ENTSOE</span>
                    </a-button>
                  </a-menu-item>
                  <a-menu-item>
                    <a-button
                      type="link"
                      title="Download files"
                      @click="() => downlodFiles(record.output_artefacts_path)"
                    >
                      <span>Download files</span>
                    </a-button>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </a-table>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Col, Row, Space } from 'ant-design-vue'
Vue.use(Row, Col, Button, Space)

// import { mapState, mapGetters } from 'vuex'
import ApiService, { XmlService } from '@/services/api'
import moment from 'moment'

import { notification } from 'ant-design-vue'

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Delivery date',
    dataIndex: 'delivery_date',
    scopedSlots: { customRender: 'dateFormat' },
  },
  {
    title: 'Started',
    dataIndex: 'created_at',
    scopedSlots: { customRender: 'dateTimeFormat' },
  },
  {
    title: 'Last run',
    dataIndex: 'last_run_status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: 'Err. Message',
    dataIndex: 'error_message',
    scopedSlots: { customRender: 'errorMessage' },
  },
  {
    title: 'To CGES',
    dataIndex: 'cges_xml_sent_at',
    scopedSlots: { customRender: 'dateTimeFormatCges' },
  },
  {
    title: 'To COTEE',
    dataIndex: 'cotee_xml_sent_at',
    scopedSlots: { customRender: 'dateTimeFormatCotee' },
  },
  {
    title: 'To ENTSOE',
    dataIndex: 'entsoe_prices_xml_sent_at',
    scopedSlots: { customRender: 'dateTimeFormatCotee' },
  },
  {
    title: 'Actions',
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  props: {},
  data: function () {
    return {
      moment,
      syncing: false,
      sending: false,
      columns,
      loading: true,
      files: [],
      expandedRowKeys: [],
    }
  },
  methods: {
    async sync() {
      this.syncing = true
      const response = await XmlService.sync()
      if (response.data.success) {
        notification.success({
          message: response.data.message,
        })
      } else {
        notification.error({
          message: response.data.message,
        })
      }
      this.syncing = false
      this.getData()
    },
    async sendEmail(record, destination) {
      this.sending = true
      const response = await XmlService.sendEmail(record.id, destination)
      if (response.data.success) {
        notification.success({
          message: response.data.message,
        })
      } else {
        notification.error({
          message: response.data.message,
        })
      }
      this.sending = false
      this.getData()
    },
    downlodFiles(path) {
      XmlService.getZip(path).then((response) => {
        const uuid = response.data
        ApiService.downloadFile(`zip-file/${uuid}`, `${path.replaceAll('/', '-')}.zip`)
      })
    },
    timeClasses(time) {
      return {
        'font-size-12': true,
        badge: true,
        'badge-success': time != null,
      }
    },
    statusClasses(text) {
      return {
        'font-size-12': true,
        badge: true,
        'badge-success': text == 'success' || text == 'ok',
        'badge-danger': text != 'success' && text != 'ok',
      }
    },
    statusText(text) {
      if (text) {
        var parts = text.split('_')
        parts[0] = parts[0].toUpperCase()
        return parts.join(' ')
      }
      return ''
    },
    getData() {
      this.loading = true
      XmlService.getDownloadedFiles().then((response) => {
        const rawResults = response.data
        const hierarchy = {}
        for (const result of rawResults) {
          if (hierarchy[result.delivery_date]) {
            if (hierarchy[result.delivery_date].children) {
              hierarchy[result.delivery_date].children.push(result)
            } else {
              hierarchy[result.delivery_date].children = [result]
            }
          } else {
            hierarchy[result.delivery_date] = result
          }
        }

        this.files = Object.values(hierarchy)
        this.loading = false
      })
    },
  },
  watch: {},
  computed: {},
  mounted() {
    this.getData()
  },
}
</script>
